import { Component, ViewChild, Input, Output, OnChanges, EventEmitter  } from '@angular/core';
import { Service } from '../../direct-connect.service';
import { ClrWizard } from '@clr/angular';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
let $ = require('jquery');
import { AppState } from '../../../../../app.service';
import { IpValidationUtils  } from '../../../../../../common/validations/ip-validation-utils';
const _ = require('lodash');
import { VcaAlertsService } from '../../../../../../common/vca-alerts/vca-alerts.service';

@Component({
  selector: 'connect-gateway-wizard',
  styles: [require('../../direct-connect.scss')],
  template: require('./connect-gateway.html'),
   providers: [
    Service, TranslateService
  ]
})

export class ConnectGatewayWizard {
  @ViewChild('connect_gateway_wizard') wizard: ClrWizard;
  @Input() isWizardOpen: boolean = false;

  @Input() orgVdcId: string = '';
  @Input() createData: any;
  @Output() wizStatusChange: EventEmitter<any> = new EventEmitter();

  disableStep0: boolean = true;
  disableStep1: boolean = true;
  disableStep2: boolean = true;
  disableStep3: boolean = false;
  orgList: JSON;

  public stepData = [];
  public currentStepData = [];
  private subscribeHandler;

  private wizardType: string = 'Create';
  private uplinks: any;
  private isTranslationready:boolean = true;
  private crudResult: any;
  private networkDetail: any;
  private showBusy: boolean = false;
  private isNetworkCreatedPrevious: boolean = false;
  private isNetworkCreatedNow: boolean = false;
  private ipValidationUtils: IpValidationUtils = new IpValidationUtils();
  private newUplinks: any;
  private prevStepId: number = -1;

  constructor(public appState: AppState,
              public service: Service,
              private translate: TranslateService,
              private alert: VcaAlertsService) {
        translate.use(GlobalVariables.LOCALE);
  }

  toggleNextButtonStatus(state: boolean) {
      this.disableStep0 = state
      this.disableStep1 = state;
      this.disableStep2 = state;
      this.disableStep3 = state;
  }

  ngOnDestroy() {
    this.isWizardOpen = false;
  }

  ngOnInit() {
      this.stepData = [];
      this.currentStepData = [];
  }
  ngOnChanges(changes) {
    if (!this.isWizardOpen) {
      return;
    }
    this.toggleNextButtonStatus(true);
    let data = this.createData;
    this.disableStep1 = true;
    this.isNetworkCreatedPrevious = false;
    this.stepData = [];
    this.currentStepData = [];
    if (data && typeof data.subnets !== "undefined" && data.subnets.length > 0) {
        this.disableStep1 = false;
        this.isNetworkCreatedPrevious = true;
    }
  }
  addSubnetsForDirectConnect(data) {
    if (!data) {
        return;
    }
    let config = this.createData.directConnectConfiguration;
    this.isNetworkCreatedNow = true;
    let json = {
        subnets: [{
		    gatewayAddress: data.gatewayAddress,
		    maskBits: data.maskBits,
		    ipRanges: data.ipRanges
	    }]
    }
    json.subnets[0].ipRanges['valid'] = true;
    this.networkDetail = json;
    this.subscribeHandler = this.service.addSubnetsForDirectConnect(config, json)
      .subscribe(
        crudResult => {
          this.crudResult = crudResult;
          //this.networkDetail = this.stepData[1];

        },
        error => this.service.logError(error, 'get uplinks error'),
        () => this.service.logOperationCompleted('get uplinks Completed')
      );
  }

  getAllUplinksOfEdge(edgeId) {
      if (!edgeId) {
        return;
      }
      this.subscribeHandler = this.service.getAllUplinksOfEdge(edgeId)
        .subscribe(
        uplinks => {
          this.uplinks = uplinks;
          this.disableStep3 = false;
          this.getNewUplinks();
        },
        error => {
          this.service.logError(error, 'get uplinks error');
          this.alert.danger(['Failed to get Uplinks', error], 'manage-uplinks-create');
          this.disableStep3 = true;
        },
        () => {
          this.service.logOperationCompleted('get uplinks Completed')
        }
      );
  }

  getNewUplinks() {
      if (!this.createData || !this.createData.network) {
          return;
      }
      let data = this.createData;
      let networkId = data.network.id;
      let found: boolean = false;
      let gatewayInterfaces = this.uplinks.gatewayInterfaces;
      for (let i = 0; i < gatewayInterfaces.length; i++) {
          if (gatewayInterfaces[i].networkId === networkId) {
            found = true;
            break;
          }
      }

      if (!found) {
          this.newUplinks = {
            networkName: data.network.name ? data.network.name: '',
            networkId: data.network.id ? data.network.id : '' ,
            operation: 'add' ,
            add: true,
            defaultRoute : false,
            connected : true,
            subnets: data.subnets? data.subnets: []
          }
      }
  }

  nextButtonClicked(stepId) {
    this.prevStepId = stepId;
     switch (stepId) {
      case 0:
        this.getAllUplinksOfEdge(this.stepData[0].edge.id);
      break;

      case 1:
        if (!this.isNetworkCreatedPrevious &&  !this.isNetworkCreatedNow) {
          this.addSubnetsForDirectConnect(this.stepData[1]);
        }
      break;

      case 4:
        this.postData();
      break;
     }
  }

  wizardStateChanged(isItOpen) {
    this.isWizardOpen = isItOpen;
    this.wizStatusChange.emit(isItOpen);
  }

  wizardPageOnLoad(event) {
  }

  onOrgChange(event) {
    this.stepData[event.stepId] = event;
  };

  isWizardOpenChange() {
  }


  toggleNextButton(formData) {
    this.currentStepData = formData;
    this.stepData[formData.stepId] = formData;

    switch (formData.stepId) {
      // Select gateway
      case 0:
            this.disableStep0 = !formData.isStepValid
      break;

      // Direct Connect Networks
      case 1:
        this.disableStep1 = (formData.isIpRangeValid) ? false : true;

      break;

      // Configure gateway
      case 2:
        this.disableStep2 = !formData.isStepValid
      break;

      // Manage Uplinks
      case 3:

      break;

      default:


    }
  }

  postData() {
      let payload = this.getPayload();
      let edgeId = this.stepData[0].edge.id;
      if (payload && edgeId) {
          this.updateUplinksOfEdge(payload, edgeId);
      }
  }

  updateUplinksOfEdge(data: any, edgeId: string) {
    if (!data) {
        return;
    }
    let obj = {'uplinks': data.uplinks.uplinks};
    this.subscribeHandler = this.service.updateUplinksOfEdge(obj, edgeId)
      .subscribe(
        crudResult => {
          this.crudResult = crudResult;
        },
        error => this.service.logError(error, 'updateUplinksOfEdge error'),
        () => this.service.logOperationCompleted('updateUplinksOfEdge Completed')
      );
  }

  getExistingIPRange () {
      let ranges = [];
      let rowData = this.getRowData();
      let dcNetworkId = rowData.network.id;

      if (!this.createData || !this.createData.edgesConnected) {
          return [];
      }
      let edgesConnected = this.createData.edgesConnected;
      for (let i = 0; i < edgesConnected.length; i++) {
          let gatewayInterfaces = edgesConnected[i].gatewayInterfaces;
          gatewayInterfaces.map(function(inf, index){
            let _ranges = [];
            if (inf.networkId === dcNetworkId) {
              inf.subnets.map(function(subnet, idx){
                _ranges = _ranges.concat(subnet.ipRanges);
              });
            ranges = ranges.concat(_ranges);
          }
        });
      }
      return ranges;
  }

  validateIpInSubnet (subnet,ips) {
      let __thisVar = this;
      let ipsValid = false;
      let subnetIP = $.trim(subnet[0]);
      let netMask  = $.trim(subnet[1]);
      ips.forEach(function(el){
          ipsValid = __thisVar.ipValidationUtils.isRangeValid(el['startAddress'], el['endAddress'],subnetIP,netMask);
          return !ipsValid;
      });
      return ipsValid;
    }

  computeRangeData (subnets, subIPRanges){
      let __this = this;
      let ret = [];
      subnets.map(function(subnetItem, index){
                let _index = index;
                subnetItem.ipRanges = [];
                subIPRanges.map(function(ipRange, idx){
                    let ipRanges = [];
                    ipRanges.push(ipRange);
                    let inSubnet = __this.validateIpInSubnet([subnetItem.gatewayAddress, subnetItem.maskBits], ipRanges);
                    if(inSubnet){
                      subnetItem.ipRanges.push(ipRange);
                    }
                });
                ret.push(subnetItem);
      });
      return ret;
  }

  getEdgeData() {
    let data = {
        gatewayRanges: {ipRanges: $.extend(true, [], this.stepData[2].ipRanges)},
	      edgeId: this.stepData[0].edge.id,
	      edgeName: this.stepData[0].edge.name,
        uplinks: []
    }
    return data;
  }

  getMainSubnets() {
      if (this.isNetworkCreatedNow) {
          let data = $.extend(true, [], this.networkDetail);
          delete data['dcName'];
          delete data['isIpRangeValid'];
         // delete data['subnets'];
          delete data['stepId'];
          return [data];
      } else {
        return this.createData.subnets;
      }
  }

  getRowData() {
      return this.createData;
  }

  getUplinks() {
      if (this.uplinks && this.uplinks.gatewayInterfaces) {
          return this.uplinks.gatewayInterfaces;
      }
      return [];
  }

  isUplinkChecked(networkId: string) {
      let uplinksSelection = this.stepData[3].uplinksSelection;
      for (let i = 0; i < uplinksSelection.length; i++) {
          if (uplinksSelection[i].id === networkId && uplinksSelection[i].selected) {
              return true;
          }
      }
      return false;
  }


getSubIPRanges() {
    return (this.stepData[2]? this.stepData[2].ipRanges: []);
}

getPayload() {
    let _thisVar = this;
    let edgeData = this.getEdgeData();
    let rowData = this.getRowData();
    let data = {'uplinks' : []};
    let directConnectNetworkId: any;

    let mainSubnets  = this.getMainSubnets();
    let existingIPRange =  this.getExistingIPRange();

    if (typeof rowData.network !== "undefined") {
        directConnectNetworkId = rowData.network.id;
    } else if (typeof edgeData !== "undefined") {
        directConnectNetworkId = edgeData['network']['id'];
    }

    let uplinks = this.getUplinks();
    let newUP = this.newUplinks;
    if (newUP) {
        uplinks.push (newUP);
    }

    uplinks.map(function(item, index) {
        let o = {};
        o = $.extend(true, {}, item);
        if (item.networkId === _thisVar.createData.network.id) {
          o['defaultRoute'] = false;
          let subIPRanges = _thisVar.getSubIPRanges();  //edgeData.gatewayRanges.ipRanges;
          o['subnets'] = _thisVar.computeRangeData(mainSubnets, subIPRanges);
          delete o['add'];
          delete o['connected'];
          o['operation'] = 'add';
          data.uplinks.push(o);
        } else {
            if(item.networkId == directConnectNetworkId) {
              let ranges = _thisVar.getSubIPRanges(); //edgeData.gatewayRanges.ipRanges;
              o['subnets'] = _thisVar.computeRangeData(mainSubnets, ranges);
            }
            if((item.connected == undefined || item.connected == true) && !_thisVar.isUplinkChecked(item.networkId) ) {
              o['operation'] = 'delete';
              o['defaultRoute'] = false;
              delete o['connected'];
              data.uplinks.push(o);
            } else if((item.connected == undefined || item.connected == true) && _thisVar.isUplinkChecked(item.networkId)) {
            }
        }
    });

    let modified = $.extend(true, {}, data);
    modified.uplinks.map(function(item, index){
          let subs = [];
          item.subnets.map(function(subnet, index){
                if('subnetId' in subnet){
                    delete subnet.subnetId;
                }
                if(!(item.networkId === directConnectNetworkId && subnet.ipRanges.length == 0)){
                    subs.push(subnet);
                }
          });
          item.subnets = subs;
    });
    edgeData.uplinks = modified;
    return edgeData;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/network/direct-connect/wizards/connect-gateway/connect-gateway.wizard.ts